  import React, { useState, useContext } from "react";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import {
    faTachometerAlt,
    faUserGraduate,
    faEnvelope,
    faMoneyBill,
    faFileInvoiceDollar,
    faReceipt,
    faTools,
    faSignOutAlt,
    faChevronDown,
    faChevronUp,
    faBuilding,
    faUserPlus, // Icon for user registration
  } from "@fortawesome/free-solid-svg-icons";

  import logo from "../Assets/Kalam Kids Logo_newlogo.png";
  import { useNavigate, useLocation } from "react-router-dom";
  import { toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import { AuthContext } from "../utils/AuthContext";

  const generateAcademicYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear - 2; i <= currentYear + 2; i++) {
      years.push(`${i}-${(i + 1).toString().slice(-2)}`);
    }
    return years;
  };

  const AdmissionSvg = <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M631-219q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm110 0q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm110 0q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9Zm-651 99q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38H200Zm0-120v40-560 243-3 280Zm80-40h163q3-21 9.5-41t14.5-39H280v80Zm0-160h244q32-30 71.5-50t84.5-27v-3H280v80Zm0-160h400v-80H280v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Z"/></svg>;
  const AccountsSvg =<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M531-260h96v-3L462-438l1-3h10q54 0 89.5-33t43.5-77h40v-47h-41q-3-15-10.5-28.5T576-653h70v-47H314v57h156q26 0 42.5 13t22.5 32H314v47h222q-6 20-23 34.5T467-502H367v64l164 178ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
  const Sidebar = ({ isOpen }) => {
    const { userRole, branches, selectedBranchId, setSelectedBranchId, academicYear, setAcademicYear, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const [isAccountingOpen, setIsAccountingOpen] = useState(false);

    const academicYears = generateAcademicYears();

    const navItems = [
      {
        label: "Dashboard",
        key: "dashboard",
        icon: faTachometerAlt,
        show: userRole === "admin",
      },
      {
        label: "Manage Branches",
        key: "manageBranches",
        icon: faBuilding,
        show: userRole === "admin",
      },
      {
        label: "Register User", // New item for user registration
        key: "registerUser",
        icon: faUserPlus,
        show: userRole === "admin",
      },
      {
        label: "Enquiry",
        key: "enquiry",
        icon: faEnvelope,
        show: ["admin", "user"].includes(userRole),
      },
      {
        label: "Admission",
        key: "admission",
        icon: AdmissionSvg,
        show: ["admin", "user"].includes(userRole),
      },
      {
        label: "Students",
        key: "student",
        icon: faUserGraduate,
        show: ["admin", "user"].includes(userRole),
      },
      {
        label: "Accounting",
        key: "accounting",
        icon: AccountsSvg,
        show: ["admin", "user"].includes(userRole),
      },
    ];

    const accountingItems = [
      {
        label: "Fee Receipt",
        key: "generateBill",
        icon: faMoneyBill,
        show: ["admin", "user"].includes(userRole),
      },
      {
        label: "Fee Bill",
        key: "overall",
        icon: faFileInvoiceDollar,
        show: userRole === "admin",
      },
      {
        label: "Cash Receipt",
        key: "viewMiscBills",
        icon: faFileInvoiceDollar,
        show: ["admin", "user"].includes(userRole),
      },
      {
        label: "Voucher",
        key: "accounting",
        icon: faReceipt,
        show: ["admin", "user"].includes(userRole),
      }
      
    ];

    const handleLogout = () => {
      logout();
      navigate("/login");
      toast.success("Logout successful!");
    };

    const toggleAccountingDropdown = () => {
      setIsAccountingOpen(!isAccountingOpen);
    };

    const handleSelect = (key) => {
      if (key === "accounting") {
        toggleAccountingDropdown();
      } else {
        navigate(`/admin/${key}`);
      }
    };

    const active = location.pathname.split("/")[2];

    return (
      <div
        className={`bg-white text-black shadow-xl fixed h-full w-64 p-4 border-r transition-transform duration-300 ${isOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        {/* Logo & Role */}
        <div className="p-4 border-b border-gray-200 flex flex-col items-center">
          <img src={logo} alt="Logo" className="w-32 h-20 object-contain mb-2" />
          <h1 className="text-xs font-semibold text-[#e84c24] border border-[#e84c24] rounded-md px-4 py-1 mb-2">
            {userRole === "admin" ? "Super Admin" : "Admin"}
          </h1>
          
          {/* Branch Selector */}
          {userRole !== "admin" && branches.length > 0 && (
            <div className="w-full mt-2">
              <label className="text-[10px] text-gray-500 font-bold uppercase block mb-1">Branch</label>
              <div className="relative">
                <select
                  value={selectedBranchId || ""}
                  onChange={(e) => {
                    setSelectedBranchId(e.target.value);
                    window.location.reload(); // Reload to refresh data for the new branch
                  }}
                  className="w-full text-xs border border-gray-300 rounded-md px-2 py-2 outline-none appearance-none bg-white cursor-pointer"
                >
                  {branches.map((branch) => (
                    <option key={branch._id} value={branch._id}>
                      {branch.name}
                    </option>
                  ))}
                </select>
                <FontAwesomeIcon icon={faBuilding} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none w-3 h-3" />
              </div>
            </div>
          )}
          

        </div>

        {/* Menu */}
        <ul className="mt-4 space-y-1 overflow-y-auto h-[calc(100%-250px)] custom-scroll">
          {navItems.map(
            ({ key, label, icon, show }) =>
              show && (
                <li key={key}>
                  <button
                    onClick={() => handleSelect(key)}
                    className={`flex items-center w-full px-4 py-2 rounded-md text-sm font-medium transition duration-200 ${
                      active === key
                        ? "bg-[#16bab1] text-white shadow-inner"
                        : "hover:bg-[#16bab1]/80 hover:text-white text-gray-700"
                    }`}
                  >
                    {icon.prefix ? (
                      <FontAwesomeIcon icon={icon} className="mr-3 w-4 h-4" />
                    ) : (
                      <span className="mr-3 w-4 h-4 flex items-center justify-center">
                        {icon}
                      </span>
                    )}
                    <span>{label}</span>
                    {key === "accounting" && (
                      <FontAwesomeIcon
                        icon={isAccountingOpen ? faChevronUp : faChevronDown}
                        className="ml-auto w-3 h-3"
                      />
                    )}
                  </button>

                  {/* Accounting Dropdown */}
                  {key === "accounting" && isAccountingOpen && (
                    <ul className="pl-6 mt-1 space-y-1">
                      {accountingItems.map(
                        ({ key, label, icon, show }) =>
                          show && (
                            <li key={key}>
                              <button
                                onClick={() => navigate(`/admin/${key}`)}
                                className="flex items-center w-full px-3 py-2 rounded-md text-sm hover:bg-[#16bab1]/70 hover:text-white text-gray-600"
                              >
                                <FontAwesomeIcon
                                  icon={icon}
                                  className="mr-3 w-4 h-4"
                                />
                                {label}
                              </button>
                            </li>
                          ),
                      )}
                    </ul>
                  )}
                </li>
              ),
          )}
        </ul>

        {/* Logout */}
        <div className="absolute bottom-4 w-[85%] mx-4 pt-4 border-t border-gray-200">
          <button
            onClick={handleLogout}
            className="flex items-center w-full px-4 py-2 rounded-md text-sm text-red-600 hover:bg-red-100 transition duration-200"
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="mr-3 w-4 h-4" />
            <span>Logout</span>
          </button>
        </div>
      </div>
    );
  };

  export default Sidebar;
